//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

// TODO: PD-302554 - Delete feature flag
// JIRA ticket created to track removal of this feature flag: https://curalate.atlassian.net/browse/PD-302554
export const getIsSamplingPrepaidCampaignsEnabled = createHasFeatureSelector(
  FeatureNames.SamplingPrepaidCampaigns,
);
